<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津津食集团有限责任公司</div>
                  <p class="p1">
                    津食集团是集餐饮、服务、食品制造业、旅游业、广告装饰业、物业管理、物资储存与货运代理、经营贸易、自营和代理各类商品等多种业态于一体的国有控股企业集团。
                  </p>
         
                  <div class="img1">
                    <img src="@/assets/images/jsjt.jpg" alt="" height="450px" />
                  </div>
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>